import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { editStatus } from '../../redux/state/status';
import { SendIntentEventInterface } from '../../utils/interfaces';
import { useSocket } from '../../hook/useSocket';
import { getOS } from '../../utils/navigator';
import { editSession } from '../../redux/state/session';
import { useCacheService } from '../../hook/useCacheService';

interface Props {
    height: number;
}
const LoginIframeModal = (props: Props) => {
    // console.log("IMAGE MODAL HERE")

    const cacheService = useCacheService();

    const isLoginIframeModal = useSelector(
        (state: { status: { isLoginIframeModal: boolean } }) =>
            state.status.isLoginIframeModal
    );

    const socket = useSocket();

    const loginIframeUrl = useSelector(
        (state: { status: { loginIframeUrl: string } }) =>
            state.status.loginIframeUrl
    );

    const intentId = useSelector(
        (state: { status: { intentId: string } }) => state.status.intentId
    );

    const chatId = useSelector(
        (state: { session: { chatId: string } }) => state.session.chatId
    );

    const username = useSelector(
        (state: { session: { username: string } }) => state.session.username
    );

    const botLanguage = useSelector(
        (state: { settings: { botLanguage: string } }) =>
            state.settings.botLanguage
    );

    const processor = useSelector(
        (state: { settings: { processor: number } }) =>
            state.settings.processor
    );

    const apiPath = useSelector(
        (state: { session: { apiPath: string } }) =>
            state.session.apiPath
    );

    const brandCode = useSelector(
        (state: { settings: { brandCode: string } }) => state.settings.brandCode
    )

    const marketCode = useSelector(
        (state: { settings: { marketCode: string } }) => state.settings.marketCode
    )


    const botId = useSelector(
        (state: { session: { botId: string } }) => state.session.botId
    );

    const botName = useSelector(
        (state: { settings: {botName: string}}) =>
            state.settings.botName
    );

    const sessionId = useSelector(
        (state: { session: { sessionId: string } }) => state.session.sessionId
    );

    const dispatch = useDispatch();

    const handleClick = () => {
        // console.log("Click close login iframe modal")
        dispatch(editStatus({ name: 'isLoginIframeModal', value: false }));
        dispatch(editStatus({ name: 'loginIframeUrl', value: '' }));
        let cacheInfo = {
            sessionId: botId.toString() + sessionId,
            cacheUrl: apiPath,
            botName: botName
        }
        let data = {
            username: username,
            chatId: chatId,
            type: 'goToIntent',
            intentId: intentId,
            triggerTime: new Date().toJSON(),
            platform: 'mario',
            group_name: '',
            customer_lang_culture:
                botLanguage.toLowerCase() === 'chinese'
                    ? 'zh-cn'
                    : botLanguage.toLowerCase() === 'thai'
                    ? 'th-th'
                    : botLanguage.toLowerCase() === 'vietnamese'
                    ? 'vi-vn'
                    : botLanguage.toLowerCase() === 'vietnam'
                    ? 'vi-vn'
                    : botLanguage.toLowerCase() === 'english'
                    ? 'en'
                    : botLanguage.toLowerCase(),
            operating_system: getOS(navigator),
            screen_resolution: window.screen.width + '*' + window.screen.height,
            processor: processor,
            cacheInfo: cacheInfo,
            brandInfo : {
                brand: brandCode,
                market: marketCode
            },
        } as SendIntentEventInterface;
        dispatch(editSession({ name: 'waitingAnswerReply', value: true }));
        cacheService.setCacheByField(sessionId, 'waitingAnswerReply', true)
        // console.log(data)
        socket.sendIntentEvent(data);
    };

    return (
        <div
            style={{ height: props.height }}
            className={classNames(
                'fixed w-screen bg-fixed flex justify-center medium:items-center z-20 bg-zinc-800',
                { hidden: !isLoginIframeModal }
            )}
        >
            {/* <div className="absolute right-4 top-4">
                <img
                    onClick={handleClick}
                    alt="icon"
                    src="https://cdn-icons-png.flaticon.com/512/458/458594.png"
                    className="h-10 cursor-pointer"
                />
            </div> */}

            <div className="relative">
                <img
                    onClick={handleClick}
                    alt="icon"
                    src="https://cdn-icons-png.flaticon.com/512/458/458594.png"
                    className="absolute right-2 top-4 cursor-pointer w-8"
                />

                <iframe
                    className="w-screen medium:min-w-[600px] medium:w-[600px] h-full medium:min-h-[500px] medium:h-[500px] bg-slate-200 overflow-scroll"
                    src={loginIframeUrl}
                />
                {/* <iframe className='w-screen medium:w-[600px] h-full medium:h-[500px] bg-slate-200 overflow-scroll' src={'https://www.wikipedia.com'} /> */}
            </div>
        </div>
    );
};

LoginIframeModal.propTypes = {};

export default LoginIframeModal;
